import { useContext } from 'react'

import { PassContext } from "../pass-context"
import dataSelector from './data-selector'
import PopupEditor from './popup-editor'
import { PassImage } from '/components/editor/pass-image'

const LockScreen = () => {

  const { model, template, variables } = useContext(PassContext)

  const iconPath = "meta.images.icon"
  const iconSrcUrl = dataSelector({ template, variables, path: iconPath })

  const organization_name = dataSelector({ template:model, variables, path: "organizationName" })

  return (
    <div className="lock-screen" style={{backgroundColor:"white", color:"black"}}>
      <table width="100%">
        <tbody>
          <tr>
            <td valign="middle" width={75}>
              <PopupEditor title="Icon Image" path={iconPath}>
                <div className="image" style={{ position: "relative" }}>
                  <div style={{ position: "absolute", height:50, width:50, overflow:"hidden"}} className="editable" />
                  <PassImage src={iconSrcUrl} height={50} width={50} />
                </div>
              </PopupEditor>
            </td>
            <td valign="middle">
              <PopupEditor title="Organisation name" path="organizationName" variable="pass.issuer_name">
                <div className='title editable overflow-hidden'>
                  {organization_name}
                </div>
              </PopupEditor>

              <div className='body'>notification message</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}

export default LockScreen
